module.exports = __webpack_public_path__ + "static/img/成型CUT机.b64316c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/atlas/instructionsIimags/成型CUT机.jpg
// module id = iRFE
// module chunks = 1